module.exports = __webpack_public_path__ + "img/icon-drop-down.3cee50d3.svg";